<ng-container *ngIf="state.active && overlayReady">
  <div class="tour-backdrop" (click)="onBackdropClick()">
    <svg class="tour-svg" width="100%" height="100%">
      <defs>
        <mask id="tour-mask">
          <rect width="100%" height="100%" fill="white" />
          <rect
            class="tour-spotlight-rect"
            [attr.x]="spotlightRect.x - 6"
            [attr.y]="spotlightRect.y - 6"
            [attr.width]="spotlightRect.width + 12"
            [attr.height]="spotlightRect.height + 12"
            rx="8"
            ry="8"
            fill="black"
          />
        </mask>
      </defs>
      <rect width="100%" height="100%" fill="rgba(0,0,0,0.55)" mask="url(#tour-mask)" />
      <rect
        class="tour-spotlight-rect"
        [attr.x]="spotlightRect.x - 6"
        [attr.y]="spotlightRect.y - 6"
        [attr.width]="spotlightRect.width + 12"
        [attr.height]="spotlightRect.height + 12"
        rx="8"
        ry="8"
        fill="none"
        stroke="#1976d2"
        stroke-width="2"
      />
    </svg>
  </div>
  <div
    #popover
    class="tour-popover"
    role="dialog"
    aria-modal="true"
    tabindex="-1"
    [attr.aria-labelledby]="'gematik-tour-title'"
    [attr.aria-describedby]="'gematik-tour-content'"
    [style.top.px]="popoverTop"
    [style.left.px]="popoverLeft"
    [class.tour-popover-above]="popoverPosition === 'top'"
    [class.tour-popover-below]="popoverPosition === 'bottom'"
  >
    <div class="tour-popover-header">
      <ng-container *ngIf="!contentLoading; else titleSkeleton">
        <span class="tour-popover-title" id="gematik-tour-title">{{ currentStep?.title }}</span>
      </ng-container>
      <ng-template #titleSkeleton>
        <span class="tour-skeleton tour-skeleton-title" aria-hidden="true"></span>
      </ng-template>
      <button class="tour-close-btn" [attr.aria-label]="labels.close" (click)="onEnd()">
        <span class="tour-close-icon" aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="tour-popover-body" id="gematik-tour-content">
      <ng-container *ngIf="!contentLoading; else contentSkeleton">
        <span [innerHTML]="currentStep?.content"></span>
      </ng-container>
      <ng-template #contentSkeleton>
        <span class="tour-skeleton tour-skeleton-line" aria-hidden="true"></span>
        <span class="tour-skeleton tour-skeleton-line tour-skeleton-line-short" aria-hidden="true"></span>
      </ng-template>
    </div>
    <div class="tour-popover-footer">
      <span class="tour-step-indicator">{{ labels.stepIndicator(displayStepNumber, totalVisibleSteps) }}</span>
      <div class="tour-nav-btns">
        <button class="tour-btn tour-btn-secondary" *ngIf="displayStepIndex > 0" (click)="onPrev()">
          {{ labels.back | translate }}
        </button>
        <button class="tour-btn tour-btn-primary" (click)="onNext()">
          {{ isLastStep ? (labels.done | translate) : (labels.next | translate) }}
        </button>
      </div>
    </div>
  </div>
</ng-container>
